import Text from "./Text";
import Container from "./Container";
import PercentageText from "./PercentageText";
import Currency from "./Currency";

interface IAssetAccordionHeaderEndContentTextProps {
    title: string;
    value: number;
    isCurrency?: boolean;
    isPercentage?: boolean;
}

const AssetAccordionHeaderEndContentText = ({ title, value, isCurrency, isPercentage }: IAssetAccordionHeaderEndContentTextProps) => {
    return (
        <Container flexColumn gap={2}>
            <Text
                color="white"
                fontWeight="medium"
                size="base"
            >
                {title}
            </Text>

            {
                isPercentage && (
                    <PercentageText
                        color="white"
                        size="sm"
                        fontWeight="light"
                    >
                        {value}
                    </PercentageText>
                )
            }

            {
                isCurrency && (
                    <Currency value={value}>
                        {
                            (value) => (
                                <Text
                                    color="white"
                                    size="sm"
                                    fontWeight="normal"
                                >
                                    {value}
                                </Text>
                            )
                        }
                    </Currency>
                )
            }
        </Container>
    )
}

export default AssetAccordionHeaderEndContentText;
